<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
  maxWidth?: string | number;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const closeDialog = () => {
  emit("update:modelValue", false);
};

// Close on escape key
const handleKeydown = (e: KeyboardEvent) => {
  if (e.key === "Escape") {
    closeDialog();
  }
};

onMounted(() => {
  window.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeydown);
});
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="modelValue" class="custom-dialog-overlay">
        <div class="custom-dialog-scrim" @click="closeDialog"></div>
        <div class="custom-dialog-container">
          <div
            class="custom-dialog-content"
            :style="{ maxWidth: maxWidth ? `${maxWidth}px` : '600px' }"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.custom-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 9999;
  overflow-y: auto;
  padding: 2rem 0;
}

.custom-dialog-scrim {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(
    var(--v-overlay-scrim-background),
    var(--v-overlay-scrim-opacity)
  ) !important;
  z-index: -1;
}

.custom-dialog-container {
  width: 100%;
  padding: 0 1rem;
}

.custom-dialog-content {
  /* background: white; */
  border-radius: 4px;
  margin: 0 auto;
  width: 100%;
}

/* Transition animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
